var map = {
	"./AmpliTeach_white.png": 48,
	"./Ic_practice time.svg": 181,
	"./Singing Teacher-595b40b75ba036ed117d8efe 1.svg": 182,
	"./ampliTeach.svg": 35,
	"./arrow_down_black.svg": 124,
	"./arrow_right_white.svg": 79,
	"./assign_practice.svg": 183,
	"./attachment.svg": 132,
	"./attendance_icon.svg": 184,
	"./audio_bg.svg": 231,
	"./audio_play.svg": 232,
	"./backward_btn_icon.svg": 166,
	"./bars-progress-solid.svg": 233,
	"./book_open.svg": 185,
	"./build_my_biz_icon.svg": 186,
	"./calender_icon.svg": 148,
	"./call_icon_white.svg": 133,
	"./cart_icon.svg": 187,
	"./category.svg": 188,
	"./check-solid.svg": 234,
	"./choose_from_library.svg": 235,
	"./communication_log_icon.svg": 189,
	"./complete_Practice.svg": 190,
	"./course_img_i.jpg": 156,
	"./course_img_ii.jpg": 236,
	"./courses_graphic.png": 167,
	"./create_course_lesson.svg": 173,
	"./crossIcon.png": 237,
	"./csv_icon.svg": 152,
	"./dashboard_icon_red.svg": 154,
	"./dashboard_icon_white.svg": 238,
	"./data_not_found.svg": 122,
	"./delete.svg": 174,
	"./delete_white.svg": 134,
	"./doc.svg": 135,
	"./download.png": 239,
	"./download_red.svg": 120,
	"./download_white.png": 136,
	"./dummy.pdf": 191,
	"./empty_cart.svg": 192,
	"./file_example_MP4_480_1_5MG.mp4": 240,
	"./grid_black_icon.svg": 193,
	"./grid_red_icon.svg": 194,
	"./group_icon.png": 241,
	"./help_icon.svg": 137,
	"./ic_View_schedule.svg": 195,
	"./ic_access_practice.svg": 196,
	"./ic_message.svg": 197,
	"./icon_add_file_links.jpg": 242,
	"./icon_audio_pause.svg": 153,
	"./icon_audio_play.svg": 150,
	"./icon_calendar.svg": 243,
	"./icon_choose_file.jpg": 198,
	"./icon_clock.svg": 75,
	"./icon_clock_black.svg": 199,
	"./icon_cross_white.svg": 80,
	"./icon_date_black.png": 244,
	"./icon_date_red.png": 245,
	"./icon_date_red.svg": 155,
	"./icon_date_white.png": 246,
	"./icon_document.svg": 127,
	"./icon_dots_vertical.svg": 123,
	"./icon_guitar.svg": 247,
	"./icon_monthly_black.png": 248,
	"./icon_monthly_white.png": 249,
	"./icon_mp3.svg": 129,
	"./icon_payment.svg": 250,
	"./icon_pdf.svg": 251,
	"./icon_select_course.jpg": 175,
	"./icon_teacher.svg": 252,
	"./icon_timer_pause.svg": 253,
	"./icon_timer_play.svg": 254,
	"./icon_timer_stop.svg": 81,
	"./icon_week_black.png": 255,
	"./icon_week_red.svg": 256,
	"./icon_week_white.png": 257,
	"./icon_youtube.jpg": 168,
	"./image.svg": 130,
	"./image_upload.svg": 258,
	"./inner_profile_pic.png": 259,
	"./intstrument.jpg": 260,
	"./invalid_icon.svg": 261,
	"./invite.svg": 151,
	"./invoice_bottom_left_red_bg.svg": 262,
	"./invoice_top_right_red_bg.svg": 263,
	"./learning_icon_red.svg": 264,
	"./learning_icon_white.svg": 265,
	"./list_black_icon.svg": 200,
	"./list_red_icon.svg": 201,
	"./login_bg_left.svg": 266,
	"./login_bg_right.svg": 267,
	"./login_desc_bg.jpg": 268,
	"./login_widget_vector.svg": 202,
	"./mail_icon_white.svg": 138,
	"./member-1.png": 269,
	"./member-2.png": 270,
	"./member-3.png": 271,
	"./member-4.png": 272,
	"./members_icon_red.svg": 273,
	"./members_icon_white.svg": 274,
	"./message_icon.svg": 139,
	"./minus.svg": 275,
	"./modal_cross_icon.svg": 57,
	"./modal_cross_icon_gray.svg": 140,
	"./modal_cross_icon_white.svg": 121,
	"./msg_read_dtick.png": 141,
	"./musical-note-variant-with-thin-outline-svgrepo-com.svg": 203,
	"./no_course_for_approval.svg": 157,
	"./no_data_found_calander.svg": 204,
	"./no_notification_image.svg": 205,
	"./notification_blank_icon.svg": 142,
	"./notification_icon.svg": 143,
	"./notification_icon_white.svg": 176,
	"./order_1.png": 276,
	"./order_2.png": 277,
	"./order_3.png": 278,
	"./order_4.png": 279,
	"./payments_icon.svg": 206,
	"./payroll_icon.svg": 207,
	"./pdf.svg": 125,
	"./pdf_icon.svg": 126,
	"./play_arrow.png": 162,
	"./practice_video_icon.svg": 158,
	"./profile_pic.png": 280,
	"./progressbar_rounded_green.svg": 149,
	"./progressbar_rounded_red.svg": 281,
	"./question-sign-in-circles-svgrepo-com.svg": 208,
	"./question-svgrepo-com.svg": 282,
	"./recent_activity_1.jpg": 163,
	"./recent_activity_2.jpg": 177,
	"./recent_activity_3.jpg": 164,
	"./recent_activity_4.jpg": 178,
	"./recent_activity_5.jpg": 169,
	"./reporting_graphic.png": 283,
	"./reporting_icon_red.svg": 284,
	"./reporting_icon_white.svg": 285,
	"./schedualing_icon_red.svg": 286,
	"./schedualing_icon_white.svg": 287,
	"./school_icon.svg": 209,
	"./search_icon.svg": 119,
	"./select.png": 170,
	"./select_down_arrow.svg": 210,
	"./send.svg": 144,
	"./setting.svg": 131,
	"./smile.svg": 145,
	"./sms_icon_white.svg": 146,
	"./store_icon.svg": 211,
	"./store_loader_icon.svg": 212,
	"./stud_billing_icon_red.svg": 288,
	"./stud_billing_icon_white.svg": 289,
	"./student_myFavourite.svg": 213,
	"./student_practice_assigned.svg": 214,
	"./student_profile_pic.png": 290,
	"./student_report_icon.svg": 215,
	"./students_graphic.png": 159,
	"./success_true_tick.svg": 179,
	"./support_graphic.png": 64,
	"./support_icon.svg": 82,
	"./system_drop_down_list.svg": 216,
	"./teacher_dashboard_banner_vector.svg": 291,
	"./teacher_report.svg": 217,
	"./teachers_graphic.png": 171,
	"./teachers_profile_pic.png": 292,
	"./thumbnail.jpg": 39,
	"./triangle-exclamation-solid.svg": 293,
	"./true_tick.svg": 294,
	"./two_arrows.svg": 295,
	"./upload.png": 180,
	"./waving-hand.png": 147,
	"./welcome_chat_bg.png": 296,
	"./welcome_graphic.png": 297,
	"./word_icon.svg": 165,
	"./xmark-solid.svg": 160,
	"./youtube.svg": 128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 230;